import React, { useState, forwardRef, useImperativeHandle } from 'react'

import st from './index.scss'

/**
 *
 * children: 子组件
 * confirmText: 确定文案
 * cancelText： 取消文案
 * showConfirm：是否展示确定按钮
 * showCancel：是否展示取消按钮
 * onConfirm：确定回调
 * describe：弹框描述
 * onCancel：取消回调
 * title：弹框标题
 */
export default forwardRef(function ModalConfirmPor(
    {
        children,
        confirmText = '确定',
        cancelText = '取消',
        showConfirm = true,
        showCancel = true,
        onConfirm,
        describe,
        describeStyle,
        onCancel,
        title,
        onClick,
        ...props
    },
    ref
) {
    const [show, setShow] = useState(false)
    const [overflow, setOverflow] = useState(null)

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        show: () => handleSetShow(true),
        hide: () => handleSetShow(false)
    }))

    function handleSetShow(bool) {
        if (overflow === null) {
            setOverflow(document.body.style.overflow)
        }
        // 在显示的时候让整个浏览器不会位移
        document.body.style.overflow = bool ? 'hidden' : overflow || ''
        return setShow(bool)
    }

    return (
        <>
            {children && (
                <div
                    {...props}
                    onClick={(e) => {
                        onClick && onClick(e)
                        handleSetShow(true)
                        e.preventDefault()
                    }}
                >
                    {children}
                </div>
            )}

            {show && (
                <div
                    className={st['modal-mask']}
                    onClick={(e) => {
                        e.preventDefault()
                    }}
                >
                    <div className={st['confirm-box']}>
                        {title && <div className={st['confirm-tilte']}>{title}</div>}
                        <div
                            className={st['confirm-content']}
                            style={describeStyle}
                        >
                            {describe}
                        </div>
                        <div className={st['buttons']}>
                            {showCancel ? (
                                <div
                                    onClick={() => {
                                        onCancel
                                            ? onCancel() && handleSetShow(false)
                                            : handleSetShow(false)
                                    }}
                                    className={st['cancel-btn']}
                                >
                                    {cancelText}
                                </div>
                            ) : (
                                ''
                            )}
                            {showConfirm && showConfirm && <span></span>}
                            {showConfirm ? (
                                <div
                                    onClick={() => {
                                        if (onConfirm) {
                                            if (onConfirm()) {
                                                handleSetShow(false)
                                            }
                                        } else {
                                            handleSetShow(false)
                                        }
                                    }}
                                    className={st['confirm-btn']}
                                >
                                    {confirmText}
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
})
